import styled from "styled-components";

export const SearchContainer = styled.div`
  padding: 0 16px;

  & header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 44px;
    margin-top: 9px;

    & .arrowBack {
      width: 24px;
      height: 24px;
      cursor: pointer;
      margin-right: 11px;
    }

    & .inputSearch {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
      background: #f1f3f5;
      border-radius: 8px;
      overflow: hidden;
      box-sizing: border-box;

      & > div {
        display: flex;
        align-items: center;
        justify-content: center;
        /* width: 36px; */
        /* height: 36px; */
        padding: 8px;
        margin-left: 4px;
        box-sizing: border-box;

        & img {
          height: 20px;
          width: 20px;
          color: #4a5056;
          cursor: pointer;
        }
      }

      & input {
        width: 100%;
        height: 100%;
        background-color: #f1f3f5;
        outline: none;
        border: none;

        font-size: 16px;
        line-height: 24px;

        padding-top: 8px;
        padding-bottom: 8px;
        margin-left: 4px;

        box-sizing: border-box;

        caret-color: #ff7a00;

        &::placeholder {
          color: #878e95;
        }
      }

      & > img {
        margin-right: 14px;
        cursor: pointer;
      }
    }
  }

  & main {
    & > h1 {
      margin-top: 24px;
      margin-bottom: 16px;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
    }

    & div {
      display: flex;
      flex-wrap: wrap;

      & .item {
        font-size: 14px;
        background-color: #fff8f0;
        color: #ff7a00;
        border-radius: 20px;
        padding: 8px 12px;
        margin-right: 8px;
        margin-bottom: 10px;

        cursor: pointer;
      }
    }
  }
`;

// 검색결과 없는 경우
export const NoResult = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  margin-top: 71px;

  & h1 {
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
  }

  & p {
    margin-top: 16px;
    text-align: center;
    font-size: 14px;
    line-height: 20px;

    & span {
      color: #ff7a00;
    }
  }
  & div {
    margin-top: 24px;
    padding: 12px 57px;
    background: #ff7a00;
    border-radius: 8px;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #fff;
  }
`;

// 검색결과 있는 경우
export const Result = styled.div``;

